module.exports = __webpack_public_path__ + "742abed01d5157275e53b530dac716af.png";